import { IconButton } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const PaginationWrapper = styled.div`
  align-items: center;
  background-color: var(--color-bg-default);
  display: flex;
  flex-direction: row;
  gap: 16px;
  height: 48px;
  justify-content: flex-end;
  padding: 0 24px;
  width: 100%;

  ${DEVICE.mobile.max} {
    align-items: flex-end;
    flex-direction: column;
    gap: 8px;
    height: auto;
    padding: 8px;
  }
`;

const PaginationSecondGroup = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;

  ${DEVICE.mobile.max} {
    gap: 8px;
  }
`;

const PaginationText = styled.span`
  align-items: center;
  display: flex;
  font-size: 12px;
  line-height: 100%;
`;

const PaginationButtonGroup = styled.span`
  display: flex;
  flex-direction: row;
`;

const RowPerPageWrapper = styled.span`
  align-items: center;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  gap: 4px;

  select {
    border: none;
    color: var(--color-fg-default);
    font-size: 12px;
  }
`;

const PaginationButton = styled(IconButton)`
  margin: 6px;

  &.rotate {
    transform: rotate(180deg);
  }
`;

export {
  PaginationButton,
  PaginationButtonGroup,
  PaginationSecondGroup,
  PaginationText,
  PaginationWrapper,
  RowPerPageWrapper
};
